/**
 * MantineReactTable Portuguese (Brazil) Localization
 * Shared across all pages using MantineReactTable
 */
export const MRT_LOCALIZATION_PT_BR = {
  actions: 'Ações',
  and: 'e',
  cancel: 'Cancelar',
  changeFilterMode: 'Alterar modo de filtro',
  changeSearchMode: 'Alterar modo de busca',
  clearFilter: 'Limpar filtro',
  clearSearch: 'Limpar busca',
  clearSort: 'Limpar ordenação',
  clickToCopy: 'Clique para copiar',
  collapse: 'Recolher',
  collapseAll: 'Recolher tudo',
  columnActions: 'Ações da coluna',
  copiedToClipboard: 'Copiado para a área de transferência',
  dropToGroupBy: 'Solte para agrupar por {column}',
  edit: 'Editar',
  expand: 'Expandir',
  expandAll: 'Expandir tudo',
  filterArrIncludes: 'Inclui',
  filterArrIncludesAll: 'Inclui todos',
  filterArrIncludesSome: 'Inclui alguns',
  filterBetween: 'Entre',
  filterBetweenInclusive: 'Entre inclusivo',
  filterByColumn: 'Filtrar por {column}',
  filterContains: 'Contém',
  filterEmpty: 'Vazio',
  filterEndsWith: 'Termina com',
  filterEquals: 'Igual',
  filterEqualsString: 'Igual',
  filterFuzzy: 'Aproximado',
  filterGreaterThan: 'Maior que',
  filterGreaterThanOrEqualTo: 'Maior ou igual a',
  filterInNumberRange: 'Entre',
  filterIncludesString: 'Contém',
  filterIncludesStringSensitive: 'Contém (SENSITIVE)',
  filterLessThan: 'Menor que',
  filterLessThanOrEqualTo: 'Menor ou igual a',
  filterMode: 'Modo de filtro: {filterType}',
  filterNotEmpty: 'Não vazio',
  filterNotEquals: 'Diferente',
  filterStartsWith: 'Começa com',
  filterWeakEquals: 'Igual',
  filteringByColumn: 'Filtrando por {column} - {filterType} {filterValue}',
  goToFirstPage: 'Ir para a primeira página',
  goToLastPage: 'Ir para a última página',
  goToNextPage: 'Ir para a próxima página',
  goToPreviousPage: 'Ir para a página anterior',
  grab: 'Agarra',
  groupByColumn: 'Agrupar por {column}',
  groupedBy: 'Agrupado por ',
  hideAll: 'Ocultar tudo',
  hideColumn: 'Ocultar coluna {column}',
  max: 'Máx',
  min: 'Mín',
  move: 'Mover',
  noRecordsToDisplay: 'Nenhum registro para exibir',
  noResultsFound: 'Nenhum resultado encontrado',
  of: 'de',
  or: 'ou',
  pinToLeft: 'Fixar à esquerda',
  pinToRight: 'Fixar à direita',
  resetColumnSize: 'Redefinir tamanho da coluna',
  resetOrder: 'Redefinir ordem',
  rowActions: 'Ações da linha',
  rowNumber: '#',
  rowNumbers: 'Números das linhas',
  rowsPerPage: 'Linhas por página',
  save: 'Salvar',
  search: 'Buscar',
  select: 'Selecionar',
  selectedCountOfRowCountRowsSelected: '{selectedCount} de {rowCount} linha(s) selecionada(s)',
  showAll: 'Mostrar tudo',
  showAllColumns: 'Mostrar todas as colunas',
  showHideColumns: 'Mostrar/Ocultar colunas',
  showHideFilters: 'Mostrar/Ocultar filtros',
  showHideSearch: 'Mostrar/Ocultar busca',
  sortByColumnAsc: 'Ordenar por {column} ascendente',
  sortByColumnDesc: 'Ordenar por {column} descendente',
  sortedByColumnAsc: 'Ordenado por {column} ascendente',
  sortedByColumnDesc: 'Ordenado por {column} descendente',
  thenBy: ', então por ',
  toggleDensity: 'Alternar densidade',
  toggleFullScreen: 'Alternar tela cheia',
  toggleSelectAll: 'Alternar selecionar tudo',
  toggleSelectRow: 'Alternar selecionar linha',
  toggleVisibility: 'Alternar visibilidade',
  ungroupByColumn: 'Desagrupar por {column}',
  unpin: 'Desafixar',
  unpinAll: 'Desafixar tudo',
  unsorted: 'Não ordenado',
};
